module.exports = __webpack_public_path__ + "static/media/ice25.245dd056.webp";